import { useEffect, useRef, type ReactElement } from 'react';
import { Link } from 'react-router';
import { INBOX_PATH } from './paths';
import styles from './AccessDenied.module.css';

/**
 * O que o atendente vê em /admin. É só explicação: nenhuma rota de administração é chamada (a
 * guarda fica ANTES de qualquer tela que busque dados) e o servidor também recusaria (403).
 */
export function AccessDenied(): ReactElement {
  const headingRef = useRef<HTMLHeadingElement>(null);

  // A página acabou de abrir (o link que a pessoa clicou saiu de cena): o foco não pode ficar no <body>.
  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <main className={styles.page}>
      <div className={styles.card}>
        <h1 ref={headingRef} tabIndex={-1} className={styles.title}>
          Acesso negado
        </h1>
        <p className={styles.text}>
          A administração é só para administradores, e o seu usuário é de atendente.
        </p>
        <p className={styles.text}>
          Se você precisa de acesso, fale com um administrador da equipe.
        </p>
        <Link to={INBOX_PATH} className={styles.link}>
          Ir para a caixa de entrada
        </Link>
      </div>
    </main>
  );
}
